import type { ThemeMeta, ThemeTokens } from '@/previewThemes/meta';

/**
 * Emeraude's design constants.
 *
 * A fine-jewellery house: white pages, a deep emerald-teal that signs the
 * announcement rail, the buttons and the footer, a classical serif for every
 * heading and a quiet sans for the fine print. Products stand in thin-framed
 * tiles on a pale ground - the way a jeweller's case lays a piece on velvet -
 * so a ring and a necklace read at the same weight on one shelf.
 *
 * The shop it is previewed with is a jewellery store stocked with the
 * platform's own Jewellery library pictures - see `catalog.ts` for why it
 * ships its own, and `photos.ts` for where each picture came from.
 */
export const tokens: ThemeTokens = {
  // A book serif with real contrast, which is what makes a product name read
  // as engraved rather than typed. Set at 500 so it holds on a phone.
  headingFont: 'EB Garamond',
  // Gold: the sale badge, the saving line and the in-stock note. Used sparingly
  // - one warm note against the teal is what makes the teal read as emerald.
  accent: '#b08d4a',
  monoFont: null,
  headingTracking: '0.005em',
  headingTransform: 'none',
  // Every section is announced from the centre, over a centred subtitle.
  headingAlign: 'center',
  containerMax: '84rem',
  spaceScale: 1.15,
  // The marquee rail and a single-deck masthead with a hairline under it.
  headerHeight: '7.5rem',
};

export const meta: ThemeMeta = {
  label: 'Emeraude',
  hint: 'A fine-jewellery house: emerald and gold, framed product tiles and a mega-menu masthead.',
  industries: ['jewellery'],
  look: {
    colors: {
      primary: '#1c3f3f',
      background: '#ffffff',
      surface: '#f5f5f2',
      text: '#1f2a2a',
      muted: '#6b7472',
    },
    typography: {
      font_family: 'Montserrat',
      heading_font: 'EB Garamond',
      heading_weight: '500',
    },
    // Softly squared: rounder than a tile, never a pill.
    buttons: { radius_px: 8, style: 'solid' },
    // No `catalog` named: this theme ships its own in `catalog.ts`.
  },
};
